import {
  selectPersonnelsStore,
  selectRequestFormStore,
  useBoundStore,
} from "@/services";
import { has } from "lodash";
import { useEffect } from "react";
import { VisitDetailsField } from "../types";
import { UseEditProps } from "./types";

export const useEdit = ({
  data,
  purpose,
  handleDataChange,
  handleNumbersChange,
  isPresettedPersonnelMode,
}: UseEditProps) => {
  const { requestFormData } = useBoundStore(selectRequestFormStore);

  const { personnels, selectedPersonnelMode, setSelectedPersonnelMode } =
    useBoundStore(selectPersonnelsStore);

  useEffect(() => {
    if (data) {
      const { Lookups, LOARequestBasicDetails, LoaWorkers } = data;

      const _LoaWorkers = LoaWorkers?.LoaWorkers || [];

      const _numberOfPersonnel = LOARequestBasicDetails?.Number_Of_Persons;

      const setPersonnelsNumbersField = () => {
        if (!has(requestFormData, VisitDetailsField.NumberOfPersonnel)) {
          handleNumbersChange(
            _numberOfPersonnel,
            VisitDetailsField.NumberOfPersonnel,
          );
        }
      };

      const caseWithPersonnelsInData = () => {
        if (
          _numberOfPersonnel &&
          +_numberOfPersonnel > 0 &&
          selectedPersonnelMode !== 1
        ) {
          setPersonnelsNumbersField();

          if (selectedPersonnelMode !== 0) {
            setSelectedPersonnelMode(personnels?.length ? 1 : 0);
          }
        } else {
          if (selectedPersonnelMode !== 1) {
            setSelectedPersonnelMode(1);
          }
        }
      };

      const caseWithoutPersonnelsInData = () => {
        if (_numberOfPersonnel && +_numberOfPersonnel > 0) {
          setPersonnelsNumbersField();

          if (selectedPersonnelMode !== 1) {
            setSelectedPersonnelMode(1);
          }
        } else {
          if (selectedPersonnelMode !== 0) {
            setSelectedPersonnelMode(0);
          }
        }
      };

      if (!isPresettedPersonnelMode) {
        if (_LoaWorkers.length > 0) {
          caseWithPersonnelsInData();
        } else {
          caseWithoutPersonnelsInData();
        }
      }

      if (
        purpose.Purpose.length &&
        !requestFormData?.[VisitDetailsField.Purpose] &&
        Lookups.ServicePurposeLookup.ServicePurposes?.length
      ) {
        handleDataChange(
          {
            ...Lookups?.ServicePurposeLookup?.ServicePurposes?.[0],
            Value:
              Lookups?.ServicePurposeLookup?.ServicePurposes?.[0]?.PurposeEn,
          },
          VisitDetailsField.Purpose,
        );
      }

      if (!has(requestFormData, VisitDetailsField.NumberOfVehicles)) {
        handleNumbersChange(
          LOARequestBasicDetails?.Number_Of_Vehicles,
          VisitDetailsField.NumberOfVehicles,
        );
      }

      if (!has(requestFormData, VisitDetailsField.NumberOfCameras)) {
        handleNumbersChange(
          LOARequestBasicDetails?.Number_Of_Camera,
          VisitDetailsField.NumberOfCameras,
        );
      }

      if (!has(requestFormData, VisitDetailsField.NumberOfVessels)) {
        handleNumbersChange(
          LOARequestBasicDetails?.Number_Of_Vessles,
          VisitDetailsField.NumberOfVessels,
        );
      }

      if (!requestFormData?.[VisitDetailsField.From]) {
        handleDataChange(
          new Date(LOARequestBasicDetails?.Start_date),
          VisitDetailsField.From,
        );
      }

      if (!requestFormData?.[VisitDetailsField.To]) {
        handleDataChange(
          new Date(LOARequestBasicDetails?.End_Date),
          VisitDetailsField.To,
        );
      }
    }
  }, [
    data,
    handleDataChange,
    handleNumbersChange,
    isPresettedPersonnelMode,
    personnels?.length,
    purpose,
    requestFormData,
    selectedPersonnelMode,
    setSelectedPersonnelMode,
  ]);
};
